<template>
  <div>
    <div class="header">
      <div class="logo">
        <div class="logo_left">
          <img src="../assets/jpg/logo.png" alt />
          <!-- <p>FAMILY OF CONSUMER COMPANIES</p> -->
        </div>
        <div class="logo_right">
          <p>WWID:{{ this.wwid }}</p>
          <p>用户名:{{ this.name }}</p>
        </div>
      </div>
      <div class="nav">
        <div
          class="tian"
          @click="changeTian"
          :class="{ isActive: flag == 'tian' }"
        >
          <p>{{ PosTit }}</p>
          <span>Pos Summary</span>
        </div>
        <div
          class="pos"
          @click="changePos"
          :class="{ isActive: flag == 'pos' }"
        >
          <p>{{ TmallTit }}</p>
          <span>Tracking</span>
        </div>
        <div
          class="market"
          @click="changeMar"
          :class="{ isActive: flag == 'market' }"
        >
          <p>{{ MarketTit }}</p>
          <span>Market</span>
        </div>
      </div>
    </div>
    <div class="container" id="container">
      <MyMask ref="change"></MyMask>
      <!-- 提示框 -->
      <van-overlay :show="show" z-index="99999">
        <div class="wrapper" @click.stop>
          <div class="block">
            <h4 style="margin: 30px auto 10px; font-weight: bold">更新说明</h4>
            <p
              style="
                color: rgb(121, 121, 121);
                font-size: 16px;
                padding: 5px 10px;
                line-height: 26px;
                margin: -3px auto 18px;
                display: block;
                width: 85%;
                text-align: left;
              ">
<!--1 618第一波销售额=现货GMV<br/>-->
1.  Vs·ly同期: 为{{ startTime }}至今销售额累加数对比{{ lyStarYear }}年5月25日~6月20日同期销售额<br/>
2. 猫系数据预计每天上午11点更新前一天数据，非猫系数据预计每天下午4点更新前一天数据<br/>
3. 当前各渠道数据更新情况：<br/>
    天猫品牌旗舰店数据更新至 {{TmallBrandTime}}<br/>
    <!--天猫超市数据更新至 {{TmallMarketTime|dateFormat}}<br/>-->
    <!-- 预售数据更新至 {{salesTime|dateFormat}}<br/> -->
    其余渠道数据更新至 {{OtherTime|dateFormat}}
    
            </p>
            <van-button
              size="large"
              block
              style="
                border-radius: 0px 0px 8px 8px;
                height: 52px;
                line-height: 52px;
              "
              @click="show = false"
            >
              <span>
                <p
                  style="
                    color: rgb(103, 109, 143);
                    font-size: 18px;
                    margin-top: -10px;
                  "
                >
                  <b>我知道了</b>
                </p>
              </span>
            </van-button>
          </div>
        </div>
      </van-overlay>
      <!-- <keep-alive> -->
      <transition>
        <Pos v-if="flag == 'tian'"></Pos>
        <Tian v-else-if="flag == 'pos'"></Tian>
        <Market v-else-if="flag == 'market'"></Market>
      </transition>
      <!-- </keep-alive> -->
    </div>
  </div>
</template>
<script>
import Tian from "@/components/TianMao/Tian";
import Pos from "@/components/Pos/Pos";
import Market from "@/components/Market/IndexMarket";
import MyMask from "@/components/public/mask";
import qs from "qs";
import $ from "jquery";
export default {
  name: "index",
  data() {
    return {
      show: true,
      messageTie: `
`,
      active: 0,
      flag: "tian",
      name: "",
      wwid: "",
      PosTit: "电商",
      TmallTit: "天猫旗舰店",
      MarketTit: "市场动态",
      TmallBrandTime:'',
      TmallMarketTime:'',
      salesTime:'',
      OtherTime:'',
      startTime:'',
      lyStarYear:''

    };
  },
  methods: {
    getMsgNotice() {
      this.$addr
        .post("Log/getNotice", qs.stringify({ menuId: "1" }))
        .then((res) => {
          if (res.data.data.isEffective == 1) {
            this.show = true;
            this.messageTie = res.data.data.notice;
          } else {
            this.show = false;
          }
        });
    },
    getUpdateTime() {
      this.$addr.post("Sales/getUpdateDate").then((res) => {
        console.log(res.data)
        const datetime=res.data.data[0]
        var time1= new Date(datetime.cyberwayMaxDate.time);
        var y1 = time1.getFullYear();
        var m1 = (time1.getMonth() + 1).toString().padStart(2, 0);
        var d1 = time1.getDate().toString().padStart(2, 0);
        this.TmallBrandTime=`${y1}-${m1}-${d1}`
        this.TmallMarketTime=datetime.posBySyn
        this.salesTime=datetime.yqByCyberway
        this.OtherTime=datetime.posByHand

         const startYear = res.data.data[0].startDate.substr(2, 2);
        const startMon = res.data.data[0].startDate.substr(4, 2);
        const startDay = res.data.data[0].startDate.substr(6, 2);
        const endMon = res.data.data[0].endDate.substr(4, 2);
        const endDay = res.data.data[0].endDate.substr(6, 2);
        this.startTime = `${startYear}年${startMon}月${startDay}日`;
        this.lyStarYear = res.data.data[0].lyStartDate.substr(2, 2);

      });
    },
    sendTime(menu) {
      var time = new Date();
      var y = time.getFullYear();
      var m = (time.getMonth() + 1).toString().padStart(2, "0");
      var d = time.getDate().toString().padStart(2, "0");
      var h = time.getHours().toString().padStart(2, "0");
      var mm = time.getMinutes().toString().padStart(2, "0");
      var s = time.getSeconds().toString().padStart(2, "0");
      var EndTime = `${y}-${m}-${d} ${h}:${mm}:${s}`;
      const sendEnd = {
        startDate: EndTime,
        endDate: "",
        wwid: JSON.parse(sessionStorage.getItem("userInfo")).wwid,
        name: JSON.parse(sessionStorage.getItem("userInfo")).name,
        menu: "数据作战室",
        operationModule: menu,
      };
      this.$addr.post("Log/insert", qs.stringify(sendEnd)).then((res) => {});
    },
    changeTian() {
      this.flag = "tian";
      sessionStorage.setItem("long", this.flag);
      this.sendTime("天猫旗舰店");
      this.$refs.change.loadFun();
    },
    changePos() {
      this.flag = "pos";
      this.sendTime("电商");
      sessionStorage.setItem("long", this.flag);

      this.$refs.change.loadFun();
    },
    changeMar() {
      this.flag = "market";
      this.sendTime("市场动态");

      this.$refs.change.loadFun();
    },

    getUserInfo() {
      sessionStorage.setItem("long", "tian");
      sessionStorage.setItem("longFlag", "");
      if (sessionStorage.userInfo != undefined) {
        const user = JSON.parse(sessionStorage.userInfo);
        this.name = user.name;
        this.wwid = user.wwid;
      } else {
        this.$router.push({ path: "/" });
      }
    },
  },
  components: {
    Tian,
    Pos,
    MyMask,
    Market,
  },
  created() {
    // this.getMsgNotice();
    this.getUpdateTime()
    this.sendTime("天猫旗舰店");
    this.getUserInfo();
  },
  beforeRouteLeave(to, from, next) {
    var time = new Date();
    var y = time.getFullYear();
    var m = (time.getMonth() + 1).toString().padStart(2, "0");
    var d = time.getDate().toString().padStart(2, "0");
    var h = time.getHours().toString().padStart(2, "0");
    var mm = time.getMinutes().toString().padStart(2, "0");
    var s = time.getSeconds().toString().padStart(2, "0");
    var EndTime = `${y}-${m}-${d} ${h}:${mm}:${s}`;
    const sendEndObj = {
      startDate: "",
      endDate: EndTime,
      wwid: JSON.parse(sessionStorage.getItem("userInfo")).wwid,
      name: JSON.parse(sessionStorage.getItem("userInfo")).name,
      menu: "War Room",
    };
    this.$addr.post("Log/insert", qs.stringify(sendEndObj)).then((res) => {
      if (res.data.error == 0) {
        next();
      }
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}

body {
  width: 100%;
  background-image: linear-gradient(
    -1deg,
    #eeeeee 22%,
    rgba(237, 237, 237, 0.98) 93%,
    rgba(216, 216, 216, 0) 100%
  );
  min-height: 100%;
  position: relative;
  /* box-sizing: border-box; */
}
.header {
  position: relative;
  padding-top: 35px;
  top: 0;
  z-index: 99;
  background-image: url("../assets/jpg/bgkenvue.png");
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
  height: 185px;
  box-sizing: border-box;
  overflow: hidden;
}
.logo {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-left: 35px;
  height: 35px;
  width: 100%;
  margin-bottom: 20px;
}
.logo_left {
  margin-left: -30px;
}
.logo .logo_left img {
  width: 280px;
  margin-bottom: 0.2%;
}
.logo_right {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-right: 40px;
  height: 40px;
}
.logo_right p {
  font-family: "PingFangSC-Light";
  font-size: 12px;
  color: #ffffff;
  font-weight: bold;
}

.nav {
  width: 86%;
  height: 60px;
  margin: 0 auto;
  margin-bottom: 20px;
  border: 2px solid #ffffff;
  border-radius: 30px;
  box-shadow: inset -5px 0 20px 0 #912a23;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.nav .isActive {
  background: #ffffff;
  border-radius: 30px;
  height: 100%;
  color: #cc4545 !important;
}
.nav .tian,
.nav .pos {
  font-family: "PingFangSC-Medium";
  font-size: 18px;
  text-align: center;
  line-height: 20px;
  padding: 10px;
  color: #ffffff;
  min-width: 33%;
}
.nav .market {
  font-family: "PingFangSC-Medium";
  font-size: 18px;
  text-align: center;
  line-height: 20px;
  padding: 10px;
  color: #ffffff;
  min-width: 33%;
}
.nav span {
  font-size: 16px;
}
.container {
  position: relative;
  width: 100%;
  max-height: 100%;
  background: #f6f6ff;
  box-shadow: inset 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 0 0 20px 20px;
  overflow: hidden;
}
.block {
  width: 350px;
  min-height: 40px;
  line-height: 40px;
  background-color: #fff;
  text-align: center;
  font-size: 20px;
  border-radius: 8px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue